import { MapEventOf } from 'mapbox-gl';

import { Coordinates } from '@/types/commons/commons.types';

import { useMapLayerMouseEvent } from './useMapLayerMouseEvent';

export const useMapSelectPosition = (
  isSelectionEnabled: boolean,
  setSelectedPosition: (position: Coordinates) => void,
) => {
  const onClick = (event: MapEventOf<'click'>) => {
    if (isSelectionEnabled) {
      setSelectedPosition({
        latitude: Number(event.lngLat.lat.toFixed(5)),
        longitude: Number(event.lngLat.lng.toFixed(5)),
        type: '2D',
      });
    }
  };

  useMapLayerMouseEvent('click', onClick);
};
